"use client";
import type { ReactElement } from "react";
import { motion, type MotionValue } from "framer-motion";
import { FontWeight } from "@/theme/typography";
import { CmarkdownLabelText } from "../Cmarkdowntext/CmarkdownLabelText";
import { EVENT_CARD_WIDTH } from "./timeline-constants";
import type { TimelineEvent } from "./timeline-types";
import type { TimelineEventHoverPayload } from "./timeline-period-types";
import { TIMELINE_LABEL_TEXT_ALIGN_CENTER, selectTimelineEventCardModel, } from "./timeline-period-selectors";
export interface TimelineEventCardProps {
    cardTextColor: MotionValue<string>;
    eventCount: number;
    isAbove: boolean;
    onHoverEvent: (payload: TimelineEventHoverPayload | null) => void;
    periodGlobalIndex: number;
    periodLabel: string;
    timelineEvent: TimelineEvent;
}
export function TimelineEventCard({ cardTextColor, eventCount, isAbove, onHoverEvent, periodGlobalIndex, periodLabel, timelineEvent, }: TimelineEventCardProps): ReactElement {
    const cardModel = selectTimelineEventCardModel({
        isAbove,
        periodGlobalIndex,
        eventIndex: timelineEvent.eventIndex,
        eventCount,
    });
    return (
    <motion.div data-el="Cmarkdowntimeline/TimelineEventCard/Root" key={`${periodGlobalIndex}-event-${timelineEvent.eventIndex}`} initial={{ opacity: 0, y: cardModel.initialY }} animate={{ opacity: 1, y: 0 }} transition={{
            duration: 0.24,
            delay: cardModel.delaySeconds,
            ease: "easeOut",
        }} onMouseEnter={(event) => {
            onHoverEvent({
                text: timelineEvent.text,
                periodIndex: periodGlobalIndex,
                eventIndex: timelineEvent.eventIndex,
                isAbove,
                element: event.currentTarget,
            });
        }} onMouseLeave={() => {
            onHoverEvent(null);
        }} style={{
            width: EVENT_CARD_WIDTH,
            color: cardTextColor,
            padding: "10px 8px",
            borderTop: cardModel.borderTop,
            flexShrink: 0,
        }}>
      <CmarkdownLabelText dataElScope="Cmarkdowntimeline/TimelineEventCard" content={timelineEvent.text} size={15} weight={FontWeight.Medium} textAlign={TIMELINE_LABEL_TEXT_ALIGN_CENTER} style={{ width: "100%" }} paragraphStyle={{
            marginBottom: 0,
            justifyContent: "center",
        }} textStyle={{
            color: "inherit",
            lineHeight: "22px",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
        }}/>
    </motion.div>
    );
}
